var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{ref:"tableRef",attrs:{"scroll":{x: '100%', y: 260 },"data-source":_vm.tableData,"columns":_vm.columns,"components":_vm.components,"rowKey":(row) => row.model,"row-selection":_vm.rowSelection,"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }